// extracted by mini-css-extract-plugin
export default {"taskList":"task-list_taskList__5+ekM","wrapper":"task-list_wrapper__qodRw"};